export default {
  title: "Sida",
  title_kontakt: "Kontakta oss",
  title_kopvillkor: "Köpvillkor",
}